<template>
  <paginated-table
    endpoint="invoices"
    :label="$t('views.profile.invoices.title')"
    :columns="columns"
    :fetch-params="{ 'user.id': 'me' }"
    initial-sort-by="created_at"
    :initial-sort-desc="true"
    :show-generate-csv="false"
    :show-action-column="false"
    @row-clicked="showInvoice"
  >
    <template #cell(paid_at)="{ item }">
      {{
        item.paid_at
          ? $t("views.profile.invoices.status.paid")
          : $t("views.profile.invoices.status.unpaid")
      }}
    </template>
  </paginated-table>
</template>

<script>
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";
import { capitalize } from "@/helpers/filters";
import Authenticated from "@/mixins/Authenticated";

export default {
  name: "ProfileInvoices",
  components: { PaginatedTable },
  mixins: [Authenticated],
  data() {
    return {
      columns: [
        Column.withoutFilter("id", capitalize(this.$t("lists.id")), "id", { showByDefault: false }),
        new Column("period", capitalize(this.$t("invoices.fields.name")), "text"),
        new Column("created_at", capitalize(this.$t("invoices.fields.date")), "date"),
        new Column("total", capitalize(this.$t("invoices.totals.total")), "currency"),
        new Column(
          "total_with_taxes",
          capitalize(this.$t("invoices.totals.total_with_taxes")),
          "currency"
        ),
      ],
    };
  },
  methods: {
    showInvoice(item) {
      this.$router.push(`/profile/invoices/${item.id}`);
    },
  },
};
</script>

<style lang="scss">
.profile-invoices__invoices__invoice {
  margin-bottom: 20px;
}
</style>
